module.exports = __webpack_public_path__ + "static/media/mage.a4a85ee2.png";